var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWateringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Watering_Icon",
    "data-name": "Watering Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    "data-name": "Rectangle 1724",
    width: 50,
    height: 50,
    fill: "rgba(0,0,0,0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watering_Events_Icon",
    "data-name": "Watering Events Icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M25,50A25,25,0,1,1,50,25,25.028,25.028,0,0,1,25,50M25,1.575A23.425,23.425,0,1,0,48.425,25,23.452,23.452,0,0,0,25,1.575",
    transform: "translate(0 0.142)",
    fill: "#164295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M36.867,22.289a29.363,29.363,0,0,0-5.961-6.342.559.559,0,0,0-.681-.007,29,29,0,0,0-5.941,6.334C21.835,25.689,20.149,29.39,20.07,33.5c0,.079-.007.164-.007.243a8.6,8.6,0,0,0,.715,3.419,9.21,9.21,0,0,0,1,1.726,10.837,10.837,0,0,0,8.782,4.253c5.8,0,10.509-4.207,10.509-9.4,0-4.184-1.772-8.024-4.2-11.45M31.219,39.637h-.033a.575.575,0,0,1-.171-1.12,18.059,18.059,0,0,0,3.407-1.845,15.542,15.542,0,0,0,2.264-3.454.571.571,0,0,1,1.1.2v.093a6.368,6.368,0,0,1-6.57,6.122",
    transform: "translate(-5.838 -4.464)",
    fill: "#174295"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWateringIcon);
export default __webpack_public_path__ + "static/media/Watering_Icon.266c4eeb3d0cb7174029a4e0d0342726.svg";
export { ForwardRef as ReactComponent };